import { ResolveFn, RedirectCommand } from '@angular/router';

type WKAuthResolveResult = string | RedirectCommand;

export const WKAuthTokenResolver: ResolveFn<WKAuthResolveResult | null> = (route, state) => {
    // Section: PUBLIC METHODS
    //----------------------------------------------------------------------
    const fragment = window.location.hash?.substring(1);
    let authCode: string | null = null;

    if (fragment) {
        const parts = fragment.split('&');
        for (const part of parts) {
            if (part.startsWith('code=')) {
                authCode = part.substring('code='.length);
                break;
            }
        }
    }

    return authCode;
};
